export default __webpack_public_path__ + "static/media/Letters3_14.c6c32682.png";